import Promise from 'promise-polyfill'

const BusinessTripRequest = {
  namespaced: true,
  mutations: {
    reset: (state, payload) => {
    }
  },
  actions: {
    getPagination: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.getBtRequestAllUsingGET({page: payload.page})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    getRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.getBtRequestByIdUsingGET({id: payload.id})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    validateRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.validateBtRequestUsingPOST({sppd: payload.sppd})
          .then(res => {
            resolve(res.body)
          }).catch(err => reject(err))
      })
    },
    updateRequest: (context, payload) => {
      const vue = payload.vueinstance
      const requestPayload = {id: payload.sppd.id, sppd: payload.sppd}
      if (!payload.transmode) {
        requestPayload.transmode = payload.transmode
      }
      return new Promise((resolve, reject) => {
        context.dispatch('validateRequest', payload).then(res => {
          vue.$backend.businessTripRequest.updateBtRequestUsingPUT(requestPayload)
            .then(res => {
              resolve(res.body)
            }).catch(err => reject(err))
        }).catch(err => reject(err))
      })
    },
    deleteRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.deleteBtRequestUsingDELETE({id: payload.sppd.id})
          .then(res => {
            resolve()
          })
          .catch(err => reject(err))
      })
    },
    getNewRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.addNewBtRequestUsingGET()
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    addRequest: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest.insertBtRequestUsingPOST({sppd: payload.sppd})
          .then(res => {
            resolve(res.body)
          })
          .catch(err => reject(err))
      })
    },
    filter: (context, payload) => {
      const vue = payload.vueinstance
      return new Promise((resolve, reject) => {
        vue.$backend.businessTripRequest
          .getBtRequestAllFilterUsingGET({
            page: payload.page, ds: payload.ds, impokey: payload.impokey, empkey: payload.empkey, size: payload.size, batchno: payload.batchno
          }).then(res => { resolve(res.body) }).catch(err => reject(err))
      })
    },
    reset: (context, payload) => context.commit('reset', payload)
  }
}

export default BusinessTripRequest



// WEBPACK FOOTER //
// ./src/store/business-trip-request/BusinessTripRequest.js